import { useOrganization } from '../contexts/organization-context';
import { canSeeAdminFeatures } from '../lib/org-role';
import { useUser } from './use-auth';

/**
 * Whether the current viewer may see the management side of the app.
 *
 * This replaces an expression that was copy-pasted byte-for-byte into
 * `season-settings.tsx` and `income-overview.tsx`, comment and all. Two copies
 * is how the next one gets a subtly different rule.
 *
 * The decision itself lives in `lib/org-role.ts` so it can be tested without a
 * React tree; this is only the wiring to the current session and organization.
 */
export function useCanSeeAdmin(): boolean {
  const { user } = useUser();
  const { organization } = useOrganization();

  return canSeeAdminFeatures({
    role: organization?.role,
    isSuperAdmin: user?.isSuperAdmin ?? false,
  });
}
